'use strict';

class NotificationBuilder {
    constructor(id, keys) {
        this.id = id;
        this.keys = keys;
        this.options = {};
        this.status = {};
        this.ctaHandler = Function.prototype;
        this.closeHandler = Function.prototype;
        this.replaceCmsKeyArgs = Odigeo.Utils.replaceCmsKeyArgs;
    }

    withCTAHandler(ctaHandler) {
        if (Odigeo._.isFunction(ctaHandler)) {
            this.ctaHandler = ctaHandler;
        }
        return this;
    }

    withCloseHandler(closeHandler) {
        if (Odigeo._.isFunction(closeHandler)) {
            this.closeHandler = closeHandler;
        }
        return this;
    }

    withOptions(options) {
        this.options = Object.assign(this.options, options);
        return this;
    }

    withStatus(status) {
        this.status = Object.assign(this.status, status);
        return this;
    }
}

module.exports = NotificationBuilder;
